import React, {useEffect, useState, useRef} from 'react';
import {Link} from 'react-router-dom';
import './market.css';
import { isMobile } from 'react-device-detect';
import axios from 'axios';
import {keepPreviousData, useQuery} from '@tanstack/react-query';

const Soosang =()=>{
    const [zasi, setzasi] = useState(false);
    const [zmona, setzmona] = useState(true);
    const [shut, setshut] = useState([]);
    const single = 1;
    const fnax = async (single = 1 , isMobile)=>{
        const {data} = await axios.get(`/api/frize?single=${single}&mdash=${isMobile}`);         
        return data;
    };

    const {isPending, data : last} = useQuery({queryKey:['vent',single,isMobile], queryFn: ()=>fnax(single, isMobile), placeholderData: keepPreviousData,
        staleTime: 1000 * 60 * 5, gcTime: 1000 * 60 * 30
    });
   
    useEffect(() => {
        if (zasi == true) return
       
        zci = setTimeout(() => { zono(); }, 3500);
        return () => { clearTimeout(zci); };
    },
        [zmona, zasi]);

    const zono = () => {
        zoveon.current.style.transform = 'translateY(-19%)';
    
        const juki = setTimeout(() => {
    
            const babi = document.querySelector('.zlid');
           
            if(zoveon.current == null){return;};
            zoveon.current.appendChild(zoveon.current.firstElementChild);
            zoveon.current.style.transition = 'none';
            zoveon.current.style.transform = 'translateY(0%)';
            const moa = setTimeout(() => {
                zoveon.current.style.transition = 'all 0.5s';
                setzmona(!zmona);
            }, 20);
    
            clearTimeout(juki);
         
        }, 800);
    };

    const kuara = () => {
        setzasi(!zasi);
    };
    
    const kirara = () => {
        setzasi(!zasi)
    };
    const zahina = ()=>{
        setzasi(true);
    };
    const zamena =()=>{
        setzasi(false);
    };

    const zupo = () => {
        if(noflow()) return;
        setzasi(true);
        zoveon.current.style.transform = 'translateY(-19%)';
        
        const juki = setTimeout(() => {
            zoveon.current.appendChild(zoveon.current.firstElementChild);
            zoveon.current.style.transition = 'none';
            zoveon.current.style.transform = 'translateY(0%)';
            const moa = setTimeout(() => {
                zoveon.current.style.transition = 'all 0.5s';
                setnoups(false);
            }, 20);
           clearTimeout(juki);
        }, 800);
    };
    
    const zdwo = () => {
        if(ahflow()) return;
        setzasi(true);
        zoveon.current.style.transform = 'translateY(19%)';
       
        const juki = setTimeout(() => {
            zoveon.current.prepend(zoveon.current.lastElementChild);
            zoveon.current.style.transition = 'none';
            zoveon.current.style.transform = 'translateY(0%)';
            const moa = setTimeout(() => {
                zoveon.current.style.transition = 'all 0.5s';
                sethoups(false);
            }, 20);
            clearTimeout(juki);
        }, 800);
        
    };
    
    const [houps, sethoups]= useState(false);
    const ahflow = () =>{
        if(houps){
            return houps;
        }else{
            sethoups(true);
            return false;
        }
    };
    const [noups, setnoups]= useState(false);
const noflow = () =>{
    if(noups){
        return noups;
    }else{
        setnoups(true);
        return false;
    }
};

    const zoveon = useRef();
    let zci;

    return(
    <div className='menn'>
        <div className='menn2'>
            <div className='zlid' ref={zoveon} onMouseOver={kuara} onMouseOut={kirara}>
                {last?.yoso?.length >0 && last?.yoso?.map((con, i)=>{ return (<div className='kiware'>
                    <div className='fly3'>
                        <p><span>{con.name}</span><span>-{con.prize}</span></p>
                        <p>{con.title}</p>
                    </div>
                </div>)})}
            </div>
        </div>
        <div className='pontra'>
                <span className='appe' onClick={zupo} onMouseOver={zahina} onMouseOut={zamena}><img src={process.env.PUBLIC_URL+'/ups.png'}/></span>
                <span className='duue' onClick={zdwo} onMouseOver={zahina} onMouseOut={zamena}><img src={process.env.PUBLIC_URL+'/ups.png'}/></span>
        </div>
    </div>
    );
}
 
export default Soosang;